import { useEffect } from 'react';
import { SITE } from '../data/site';

interface PageMeta {
  title: string;
  description?: string;
}

function upsertMeta(name: string, content: string) {
  let tag = document.querySelector<HTMLMetaElement>(`meta[name="${name}"]`);
  if (!tag) {
    tag = document.createElement('meta');
    tag.setAttribute('name', name);
    document.head.appendChild(tag);
  }
  tag.setAttribute('content', content);
}

function upsertCanonical(href: string) {
  let link = document.querySelector<HTMLLinkElement>('link[rel="canonical"]');
  if (!link) {
    link = document.createElement('link');
    link.setAttribute('rel', 'canonical');
    document.head.appendChild(link);
  }
  link.setAttribute('href', href);
}

/**
 * Sets document title, meta description, and canonical URL for the current
 * route. `title` is used as-is (pass the full desired <title>, e.g. Home
 * passes the existing site title verbatim; inner pages pass "X | EightyThreeLabs").
 */
export function usePageMeta({ title, description }: PageMeta): void {
  useEffect(() => {
    document.title = title;
    upsertMeta('description', description ?? SITE.description);
    upsertCanonical(SITE.url + window.location.pathname);
  }, [title, description]);
}
